import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ApplicationSourceForm from './ApplicationSourceForm';

const ApplicationSourceActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ApplicationSourceEdit = (props: any) => {
  return (
    <Edit actions={<ApplicationSourceActions {...props} />} {...props}>
      <ApplicationSourceForm />
    </Edit>
  );
};

export default ApplicationSourceEdit;
